import { createContext, useContext } from 'react';
import { makeAutoObservable } from 'mobx';

export class MentionMenuStore {
  open = false;
  query = '';

  constructor() {
    makeAutoObservable(this);
  }

  setOpen(open: boolean) {
    this.open = open;
  }

  setQuery(query: string) {
    this.query = query;
  }

  reset() {
    this.open = false;
    this.query = '';
  }
}

export const MentionMenuContext = createContext<MentionMenuStore | undefined>(undefined);

export function useMentionMenu() {
  const store = useContext(MentionMenuContext);
  if (!store) {
    throw new Error('useMentionMenu must be used within a MentionMenuProvider');
  }
  return store;
}
